import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function ActionDialog({ title, options, placeholder, cta, onSubmit, onClose, required }) {
  const [choice, setChoice] = useState(options?.[0] || "");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await onSubmit([choice, text.trim()].filter(Boolean).join(" — "));
      onClose();
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="action-dialog">
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        {options && (
          <div className="flex flex-wrap gap-2">
            {options.map((o) => (
              <button key={o} type="button" onClick={() => setChoice(o)} data-testid={`action-option-${o.toLowerCase().replace(/\s+/g, "-")}`}
                className={`rounded-full border px-3 py-1.5 text-xs font-semibold ${choice === o ? "border-primary bg-primary text-primary-foreground" : "border-white/15 text-muted-foreground"}`}>{o}</button>
            ))}
          </div>
        )}
        <Textarea placeholder={placeholder || "Details (optional)"} value={text} onChange={(e) => setText(e.target.value)} data-testid="action-dialog-text" />
        <DialogFooter>
          <Button onClick={submit} disabled={busy || (required && !text.trim())} data-testid="action-dialog-submit">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : cta}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
